import { Copy, EditIcon, FavoriteIcon, Info } from '@assets/icons';
import { LinkStatus, LinkStatusMap } from '@common';
import { AppProject } from '@common';
import { MPTooltip } from '@components';
import { Typography } from 'antd';
import cs from 'classnames';
import ConditionallyRender from 'react-conditionally-render';
import Styles from './Styles.module.scss';
import useAppCard from './useAppCard';
import { EditOutlined, FileSearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

export interface IProps {
    item: AppProject;
    handleModalOpen?: (id: string | null) => void;
}

export default function IconSection({ item }: IProps) {
    const { appUri, authToken, handleAppFavorite, canEdit } = useAppCard(item);

    return (
        <div className={Styles.IconSection}>
            <div className={Styles.IconWrapper}>
                <MPTooltip
                    placement="bottomLeft"
                    title="Copy the URL"
                >
                    <Typography.Paragraph
                        copyable={{
                            tooltips: false,
                            text: appUri,
                        }}
                        className={Styles.CopyIcon}
                    ></Typography.Paragraph>
                </MPTooltip>

                <div className={Styles.Icon}>
                    <MPTooltip
                        placement="bottom"
                        title={item?.description}
                    >
                        <Info />
                    </MPTooltip>
                </div>
                <ConditionallyRender
                    condition={canEdit}
                    show={
                        <Link to={`/a/${item.name}/edit`}>
                            <div className={Styles.Icon}>
                                <MPTooltip
                                    placement="bottomRight"
                                    title="Edit App"
                                >
                                    <EditOutlined onClick={e => e.stopPropagation()} />
                                </MPTooltip>
                            </div>
                        </Link>
                    }
                />
                <ConditionallyRender
                    condition={Boolean(authToken)}
                    show={
                        <div
                            className={Styles.FavoriteIcon}
                            onClick={handleAppFavorite}
                        >
                            <MPTooltip
                                placement="bottomRight"
                                title={item?.isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                            >
                                <FavoriteIcon className={item?.isFavorite ? Styles.Favorite : ''} />
                            </MPTooltip>
                        </div>
                    }
                />

                <Link to={`/a/${item.name}`}>
                    <MPTooltip
                        placement="bottomRight"
                        title="See Details"
                        className={Styles.Icon}
                    >
                        <FileSearchOutlined
                            onClick={e => e.stopPropagation()}
                            className={Styles.FileSerach}
                        />
                    </MPTooltip>
                </Link>
            </div>
            <div className={Styles.RightCornerIcons}>
                <div className={cs(Styles.AccessTag, { [Styles.Public]: item?.accessManagement?.access === 'public' })}>
                    {item?.accessManagement?.access}
                </div>
                <div
                    className={cs(Styles.Status, {
                        [Styles.Online]: item.linkStatus === LinkStatus.ONLINE,
                        [Styles.Offline]: item.linkStatus === LinkStatus.OFFLINE,
                        [Styles.Error]: item.linkStatus === LinkStatus.ERROR,
                    })}
                >
                    {LinkStatusMap[item.linkStatus]}
                </div>
            </div>
        </div>
    );
}
